import { useState } from "react";
import { trackEvent } from "@/lib/analytics-events";

export default function BigDatesAlertsSignup() {
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [status, setStatus] = useState<"idle" | "sending" | "done" | "error">("idle");

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!consent) return;
    setStatus("sending");
    try {
      const res = await fetch("/api/public/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ first_name: firstName, email, consent, source_page: window.location.pathname }),
      });
      if (!res.ok) throw new Error();
      setStatus("done");
      trackEvent("newsletter_signup", { form_name: "big_dates_alerts", page_path: window.location.pathname });
    } catch {
      setStatus("error");
    }
  }

  return (
    <section className="section-padding bg-surface">
      <div className="max-w-xl mx-auto px-4 text-center">
        <p className="text-primary text-xs tracking-[0.3em] uppercase mb-3 font-medium">Not ready to book yet?</p>
        <h2 className="font-heading text-2xl sm:text-3xl font-semibold mb-3">Get Big Dates Alerts</h2>
        <p className="text-muted-foreground mb-6">
          Be the first to know when game dates open up or are almost sold out. No spam, just the dates that matter.
        </p>
        {status === "done" ? (
          <p className="font-medium text-foreground" role="status">
            You're on the list! We'll email you before the big dates sell out.
          </p>
        ) : (
          <form onSubmit={onSubmit} className="space-y-3 text-left">
            <div className="grid gap-3 sm:grid-cols-2">
              <input
                type="text" placeholder="First name" value={firstName} maxLength={80}
                onChange={(e) => setFirstName(e.target.value)} aria-label="First name"
                className="w-full rounded-md border border-input bg-background px-3 py-2.5 text-foreground"
              />
              <input
                type="email" required placeholder="Email" value={email} maxLength={255}
                onChange={(e) => setEmail(e.target.value)} aria-label="Email"
                className="w-full rounded-md border border-input bg-background px-3 py-2.5 text-foreground"
              />
            </div>
            <label className="flex items-start gap-2 text-sm text-muted-foreground">
              <input type="checkbox" required checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-1" />
              <span>Yes, email me Atlanta Luxury Sprinters Big Dates alerts. I can unsubscribe anytime.</span>
            </label>
            <button type="submit" disabled={status === "sending"} className="btn-primary-hero rounded-sm w-full sm:w-auto">
              {status === "sending" ? "Subscribing..." : "Subscribe"}
            </button>
            {status === "error" && <p className="text-destructive text-sm">Something went wrong. Please try again.</p>}
          </form>
        )}
      </div>
    </section>
  );
}
